export function maskCPF(cpf: string, hide?: boolean) {
  cpf = cpf.replace(/\D/g, '');
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  if (hide) {
    const documentSplited = cpf.split('.');
    return (
      '***.' +
      documentSplited[1] +
      '.' +
      documentSplited[2].split('-')[0] +
      '-**'
    );
  }

  return cpf;
}

export function maskCNPJ(cnpj: string) {
  cnpj = cnpj.replace(/\D/g, '');
  cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
  cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
  cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
  cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
  return cnpj;
}

export function maskCPFCNPJ(document?: string, hide?: boolean) {
  if (document == null) {
    return '';
  }
  document = document.replace(/\D/g, '');
  if (document.length > 11) {
    document = maskCNPJ(document);
  } else {
    document = maskCPF(document, hide);
  }

  return document;
}

//mascara de cep
export const maskZipCode = (value: number | string | undefined) => {
  if (value === undefined) {
    return '-';
  }
  const formattedValue = value.toString().replace(/\D/g, '');
  return formattedValue.replace(/^(\d{5})(\d{3})$/, '$1-$2');
};

export function maskAccount(account?: string) {
  if (account != null && account.length >= 2) {
    if ((account = account.replace(/\D/g, ''))) {
      let digit;
      digit = account.substring(account.length - 1, account.length);
      account = account.substring(0, account.length - 1);
      return `${account}-${digit}`;
    }
  }
  return '0000-0';
}

export function maskAgency(agency?: string) {
  if (agency != null) {
    agency = agency.replace(/\D/g, '');

    switch (agency.length) {
      case 1:
        return '000' + agency;
      case 2:
        return '00' + agency;
      case 3:
        return '0' + agency;
      default:
        return agency;
    }
  } else {
    return '0000';
  }
}

export function maskMonetaryValue(
  value: any,
  prefix = 'R$ ',
  isDividedBy100 = true,
) {
  let monetary = value;

  if (monetary != null) {
    if (isDividedBy100) {
      monetary = monetary.replace(/\D/g, '');
      monetary = (monetary / 100).toFixed(2) + '';
    } else if (value.indexOf('.') === -1) {
      monetary = parseFloat(monetary).toFixed(2).toString();
    }
    monetary = monetary.replace('.', ',');
    monetary = monetary.replace(/(\d)(\d{3})(\d{3}),/g, '$1.$2.$3,');
    monetary = monetary.replace(/(\d)(\d{3}),/g, '$1.$2,');
    monetary = prefix + monetary;
    return monetary;
  } else {
    return '';
  }
}

export function convertIrregularDateFormat(input: string | undefined): string {
  const dateStr = input?.toString();
  if (dateStr != null) {
    if (dateStr.length !== 8) {
      throw new Error('O formato da data deve conter 8 dígitos (DDMMYYYY).');
    }

    const day = dateStr.slice(0, 2); // Pega os dois primeiros caracteres
    const month = dateStr.slice(2, 4); // Pega os próximos dois caracteres
    const year = dateStr.slice(4); // Pega os últimos quatro caracteres

    return `${day}/${month}/${year}`; // Retorna no formato DD/MM/YYYY
  }
  return '';
}

export const moneyMask = (value: string) => {
  const words = value.replace(/[^a-zA-Z]/g, '').replace('R', '');
  const tempValue = value.replace(/\D/g, '');

  if (Number(tempValue) === 0) {
    return 'R$ 0,00';
  }
  if (words.length > 0) {
    return 'R$ ' + value.replace(/[^0-9,\.]/g, '');
  }

  const monetaryValue = (parseFloat(tempValue) / 100).toFixed(2);

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat('pt-BR', options).format(
    Number(monetaryValue),
  );
  return 'R$ ' + result;
};

export const formatCurrency = (value: number | string): string => {
  if (value === null || value === undefined || value === '') return '';

  const numericValue =
    typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;

  return numericValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export function maskOnlyNumbers(numbers: string) {
  numbers = numbers.replace(/[^0-9]/g, '');
  return numbers;
}
